import { WalletPubDto } from "../../../../../../../api/member";
import { WalletLogTab, WalletTab } from "../../../../hooks/use-wallet-tab";
import { useWalletContext } from "../../../../hooks/wallet-context";
import {
  WalletPubListItemInfo,
  WalletPubListItemInfoWrapper,
  WalletPubListItemPub,
  WalletPubListItemPubPoint,
  WalletPubListItemTopWrapper,
  WalletPubListItemWrapper,
} from "./style";

interface WalletPubListItemProps {
  item: WalletPubDto;
  setSelectedId: (v: number) => void;
  isSelected: boolean;
}

const WalletPubListItem = ({
  item,
  setSelectedId,
  isSelected,
}: WalletPubListItemProps) => {
  const { setWalletTab, setLogTab, setSelectedPub } = useWalletContext();

  const handleItemClick = () => {
    if (item.pubType === "VIP") return;
    if (isSelected) {
      setSelectedId(-1);
      return;
    }
    setSelectedId(item.id);
  };

  const pointType = () => {
    switch (item.pubType) {
      case "FRANCHISE":
        return "E";
      case "RUNNER":
        return "M";
      default:
        return "Point";
    }
  };

  const exchangePoint = () => {
    switch (item.pubType) {
      case "FRANCHISE":
        return item.point / 10000;
      case "RUNNER":
        return item.mileage;
      default:
        return item.point;
    }
  };

  const handlePage = (logTab: WalletLogTab) => {
    setLogTab(logTab);
    setWalletTab(WalletTab.LOGS);
    setSelectedPub(item);
  };

  return (
    <WalletPubListItemWrapper
      onClick={() => handleItemClick()}
      isSelected={isSelected}
    >
      <WalletPubListItemTopWrapper>
        <WalletPubListItemPub>
          <img
            src={
              item.coverImageUrl
                ? item.coverImageUrl
                : "/image-web/mypub/logo.svg"
            }
            alt="logo"
          />
          <div className="name">{item.pubName}</div>
        </WalletPubListItemPub>
        <WalletPubListItemPubPoint>
          <div className="point">
            {exchangePoint()?.toLocaleString()}
            <span> {pointType()}</span>
          </div>
          {item.pubType !== "VIP" && (
            <img
              src={`/image-web/mypub/${isSelected ? "up" : "down"}-arrow.svg`}
              alt=""
            />
          )}
        </WalletPubListItemPubPoint>
      </WalletPubListItemTopWrapper>
      <WalletPubListItemInfoWrapper isSelected={isSelected}>
        {item.pubType === "FRANCHISE" && (
          <WalletPubListItemInfo>
            <div className="name">매장 이용권</div>
            <div
              className="value"
              onClick={() => {
                handlePage(WalletLogTab.POINT);
              }}
            >
              {exchangePoint().toLocaleString()} E
            </div>
          </WalletPubListItemInfo>
        )}
        <WalletPubListItemInfo>
          <div className="name">주류 마일리지</div>
          <div
            className="value"
            onClick={() => {
              handlePage(WalletLogTab.MILEAGE);
            }}
          >
            {item.mileage?.toLocaleString()} M
          </div>
        </WalletPubListItemInfo>
        {item.pubType === "FRANCHISE" && (
          <WalletPubListItemInfo>
            <div className="name">부상</div>
            <div
              className="value"
              onClick={() => {
                handlePage(WalletLogTab.SUBPRIZE);
              }}
            >
              자세히 보기
            </div>
          </WalletPubListItemInfo>
        )}
      </WalletPubListItemInfoWrapper>
    </WalletPubListItemWrapper>
  );
};

export default WalletPubListItem;
